import Vue from 'vue'
import VueI18n from 'vue-i18n'
import * as web from '@/WebUtil/storage';

import en from './en.json'; // 存放英文翻譯
import cn from './cn.json'; // 存放簡體中文翻譯
import tw from './tw.json'; // 存放繁體中文翻譯

Vue.use(VueI18n)

const DEFAULT_LANG = web.getLocal(web.StorageKey.langType) || "tw"
const locales = {
    en: en,
    cn: cn,
    tw: tw
};

Vue.config.lang = DEFAULT_LANG;

const i18n = new VueI18n({
    /** 默认值 */
    locale: DEFAULT_LANG,
    messages: locales,
})
export const setup = lang => {
    if (lang == null || lang == '') {
        lang = DEFAULT_LANG;
    }
    Vue.config.lang = lang
    i18n.locale = lang
}

export default i18n


// WEBPACK FOOTER //
// ./src/lang/lang.js